import { Bus } from '@/event-bus.js'

export default{

    setReport: (state, reportData) =>{
        state.reportData.push(reportData)
    },
    addReportAgreementIndex: (state)=>{
        // if (state.reportAgreement.index > 1){
        //     return
        // }
        state.reportAgreement.index++
        Bus.$emit('addIndex');
    },
    subReportAgreementIndex: (state) => {
        state.reportAgreement.index --
    },
}